import { getMethod } from "../../api-service/api-service";
import { setNuggets, setSelectedNugget } from "./nuggetSlice";

export const getNuggetsAction = (params) => async (dispatch) => {
    try {
        const queryString = params ?
            Object.keys(params)
                .filter(key => params[key]) // Remove empty values
                .map(key => `${key}=${encodeURIComponent(params[key])}`)
                .join('&')
            : '';

        const url = `/nuggets${queryString ? `?${queryString}` : ''}`;
        const response = await getMethod(url);
        if (response.success === true) {
            dispatch(setNuggets(response?.nuggets));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
}

export const getNuggetByIdAction = (id) => async (dispatch) => {
    try {
        const response = await getMethod(`/nuggets/${id}`);
        if (response.success === true) {
            dispatch(setSelectedNugget(response?.nugget));
        }
        return response;
    } catch (error) {
        console.log("Error: ", error);
        return { success: false, message: error };
    }
}